module.exports = __webpack_public_path__ + "static/logo-inverted-5bccfc88868fb816215dc9f4b5390f2a.png";